import React from "react";
import FaqListQuestion from "../components/FaqListQuestion";
import FaqListAnswer from "../components/FaqListAnswer";
import Tabs from "../components/Tabs";
import PanelLayout from "../components/PanelLayout";
import PanelAdsHeader, { renderPanelTabLabel } from "../components/PanelAdsHeader";
import { ListSkeleton } from "../components/Skeleton";
import { connect } from "react-redux";
import * as actionsQuestion from "../redux/actions/faqQuestionActions";
import * as actionsAnswer from "../redux/actions/faqAnswerActions";
import { Translate, I18n } from "react-redux-i18n";
import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";
import "./styles/PanelAds.css";
import "./styles/Faq.css";

class Faq extends React.Component {
  componentDidMount() {
    this.fetchFaqList();
  }

  fetchFaqList = async () => {
    try {
      await this.props
        .LoadFaqQuestion(this.props.user_id, this.props.token)
        .then(() => {
          if (this.props.errorQuestion) {
            alertify.warning(I18n.t(this.props.errorQuestion));
          }
        });

      await this.props
        .LoadFaqAnswer(this.props.user_id, this.props.token)
        .then(() => {
          if (this.props.errorAnswer) {
            alertify.warning(I18n.t(this.props.errorAnswer));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { questionCount, answerCount } = this.props;

    return (
      <PanelLayout>
        <div className="panel-ads-page faq-panel-page">
          <PanelAdsHeader
            title={<Translate value="faq_title" />}
            subtitle={<Translate value="faq_subtitle" />}
          />

          <div className="panel-ads-page__tabs faq-panel-page__tabs">
            <Tabs>
              <div
                tabKey="questions"
                label={renderPanelTabLabel(
                  I18n.t("faq_question_did"),
                  questionCount
                )}
                className="col-12"
              >
                {this.props.loadingQuestion ? (
                  <ListSkeleton />
                ) : (
                  <FaqListQuestion faqList={this.props.faqListQuestion} />
                )}
              </div>
              <div
                tabKey="answers"
                label={renderPanelTabLabel(
                  I18n.t("faq_by_reply"),
                  answerCount
                )}
                className="col-12"
              >
                {this.props.loadingAnswer ? (
                  <ListSkeleton />
                ) : (
                  <FaqListAnswer faqList={this.props.faqListAnswer} />
                )}
              </div>
            </Tabs>
          </div>
        </div>
      </PanelLayout>
    );
  }
}

function mapStateToProps(reducer) {
  const faqListAnswer = reducer.faqAnswer.list || [];

  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    loadingQuestion: reducer.faqQuestion.loading,
    faqListQuestion: reducer.faqQuestion.list,
    errorQuestion: reducer.faqQuestion.error,
    loadingAnswer: reducer.faqAnswer.loading,
    faqListAnswer,
    errorAnswer: reducer.faqAnswer.error,
    questionCount: (reducer.faqQuestion.list || []).length,
    answerCount: faqListAnswer.filter(
      (item) => !item.Answer || item.Answer.length === 0
    ).length,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadFaqQuestion: (user_id, token) =>
    dispatch(actionsQuestion.loadList({ user_id, token })),
  LoadFaqAnswer: (user_id, token) =>
    dispatch(actionsAnswer.loadList({ user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Faq);
